import { StyleSheet } from 'react-native';
import React, { useState } from 'react';
import { FONT_ENUM } from '../../../types/global/fonts.types';
import { ColorScheme, theme } from '../../../constants/theme';
import { Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Typography } from '@mui/material';
import { useThemeContext } from '../../../hook/useThemeManager';
import { DiscoveryFilter, FilterItem } from '../../../data/filters/discovery.data';
import { ScreenTypes } from '../../../module/ThemeManager';

interface IFilterBlock {
    data: DiscoveryFilter;
    category: string;
    onChange?: (data: string) => void;
    onFilterPressed?: () => void;
    open?: boolean;
    onFilterSelect?: (filterItem: FilterItem, categoryId: number) => void;
    disableLine?: boolean;
    defaultValue?: string;
    selectedValue?: string;
}

const MobileFilterBlock: React.FC<IFilterBlock> = ({
    data,
    category,
    onChange,
    onFilterPressed,
    open,
    onFilterSelect,
    disableLine,
    selectedValue,
}) => {
    const { themeStyle, device } = useThemeContext();
    const styles = dynamicStyles(themeStyle, device);
    const [, setValue] = useState<any>();

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value);
        if (onChange) onChange(event.target.value);
    };

    return (
        <FormControl style={styles.dropdown}>
            <FormLabel
                style={styles.titleScreen}
                sx={{
                    border: 'none',
                    marginBottom: '5px',
                    // '&:hover': { border: `1px solid ${theme[themeStyle].primary_orange}` },
                }}>
                {data.categoryName}
            </FormLabel>
            <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <RadioGroup
                    onChange={handleChange}
                    value={selectedValue}
                    defaultChecked
                    defaultValue={selectedValue}
                    sx={{
                        display: 'grid',
                        gridTemplateRows: '1fr 1fr',
                        gridTemplateColumns: '1fr 1fr',
                        justifyItems: 'space-between',
                        alignItems: 'space-between',
                        height: 'fit-content',
                        width: '100%',
                        rowGap: { xs: '0px', sm: '10px', md: '10px' },
                    }}>
                    {data.data.list.map((tag, i) => {
                        return (
                            <FormControlLabel
                                value={tag.displayName}
                                control={
                                    <Radio
                                        sx={{
                                            color: theme[themeStyle].gray_message,
                                            '&.Mui-checked': {
                                                color: theme[themeStyle].highlight, // Color for checked state
                                            },
                                        }}
                                    />
                                }
                                label={<Typography style={styles.text}>{tag.displayName}</Typography>}
                                onClick={() => onFilterSelect && onFilterSelect(tag, data.id)}
                                key={i}
                                style={styles.text}
                                defaultValue={selectedValue}
                                defaultChecked
                                sx={{ fontFamily: FONT_ENUM.REGULAR_HEADER }}
                            />
                        );
                    })}
                </RadioGroup>
            </Box>
            {/* {!disableLine && <hr style={{ width: '100%', borderBottom: `1px solid ${theme[themeStyle].gray_text}` }} />} */}
        </FormControl>
    );
};

export { MobileFilterBlock };

const dynamicStyles = (colorScheme: ColorScheme, device: ScreenTypes) =>
    StyleSheet.create({
        mainButton: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 100,
            height: '40px',
            paddingBottom: 10,
            paddingTop: 10,
            paddingLeft: 5,
            paddingRight: 5,
            textTransform: 'none',
        },
        screenTitle: {
            fontSize: 12,
            fontWeight: '500',
            fontFamily: FONT_ENUM.MAIN_MEDIUM,
            color: theme[colorScheme].form_label,
        },
        mainText: {
            width: 'fit-content',
            textAlign: 'left',
            fontSize: 14,
            fontWeight: '600',
            color: theme[colorScheme].pure_black,
            fontFamily: FONT_ENUM.MAIN_BOLD,
        },
        title: {
            fontSize: 16,
            fontWeight: '500',
            fontFamily: FONT_ENUM.MAIN_BOLD,
        },
        caption: {
            fontSize: 12,
            fontWeight: '500',
            fontFamily: FONT_ENUM.MAIN_MEDIUM,
            color: theme[colorScheme].form_label,
        },
        dropdown: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'center',
            height: 'fit-content',
            padding: '30px',
            backgroundColor: theme[colorScheme].container_color,
            borderRadius: 10,
            margin: '20px',
        },
        titleScreen: {
            fontSize: 15,
            fontWeight: 'bold',
            fontFamily: FONT_ENUM.REGULAR_HEADER,
            color: theme[colorScheme].form_label,
            textTransform: 'capitalize',
        },
        text: {
            width: 'fit-content',
            textAlign: 'left',
            fontSize: 14,
            fontWeight: 'bold',
            fontFamily: FONT_ENUM.REGULAR_HEADER,
            color: theme[colorScheme].filters_white,
            textTransform: 'capitalize',
        },
    });
